import { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import EmbarqueDetalhes from '../../../../Tracking/Embarques/view/components/embarqueDetalhes';

const icons = {
  1: 'icofont icofont-ship',
  4: 'icofont icofont-airplane-alt',
};

const TrackingTabs = ({ processoData }) => {
  const [activeTab, setActiveTab] = useState('0');
  const embarques = processoData?.embarques ?? [];

  return (
    <>
      <Nav className='nav-primary border-tab' tabs>
        {embarques.map((embarque, index) => (
          <NavItem key={embarque.id ?? index}>
            <NavLink
              href='#'
              className={activeTab === String(index) ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab(String(index));
              }}
            >
              {icons[embarque.tipo_embarque_id] && <i className={icons[embarque.tipo_embarque_id]}></i>}
              {embarque.tipo_documento ? embarque.tipo_documento + ' ' : ''}
              {embarque.numero + (embarque.numero_house ? ' - ' + embarque.numero_house : '')}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab} className='m-t-15'>
        {embarques.map((embarque, index) => (
          <TabPane key={embarque.id ?? index} tabId={String(index)}>
            <EmbarqueDetalhes embarque={embarque} origem='processo' />
          </TabPane>
        ))}
      </TabContent>
    </>
  );
};

export default TrackingTabs;
